module.exports = __webpack_public_path__ + "static/media/82.f932d95e.gif";